import loadable from "@loadable/component";

const AccessibilityPolicy = loadable(() => import("./AccessibilityPolicy.page"));

export default { component: AccessibilityPolicy };
